import { Aside, NewsListItem } from "styles/jss/News.styles";
import DateStamp from "../../DateStamp";
import { truncateString } from "../../../utils/helperFunction";
import { useTranslation } from "next-i18next";
import HeadTitle from "./HeadTitle";

export default function AsideNews({ news }) {
  const { t } = useTranslation(["article"]);

  return (
    <Aside>
      <h3 className="title">{t("news.latest")}</h3>
      {news.map(({ id, attributes }) => {
        const { title, slug, datetime } = attributes;
        return (
          <NewsListItem key={id}>
            <HeadTitle
              as={"p"}
              url={`/media-center/news/${id}/${slug}`}
              className="content"
            >
              {truncateString(title, 100)}
            </HeadTitle>
            <DateStamp date={datetime} time />
          </NewsListItem>
        );
      })}
    </Aside>
  );
}
